// import { SynaptixClientToolkitFrLocale} from "@synaptix/ui";
import {fr as SynaptixClientToolkitFrLocale} from "@mnemotix/synaptix-client-toolkit/lib/locales/fr";

export const fr = {
  ...SynaptixClientToolkitFrLocale,
  ACTIONS: {
    ADD: "Ajouter",
    CANCEL: "Annuler",
    DELETE: "Effacer",
    GO_BACK: "Retour",
    NO_RESULT: "Aucun résultat ne correspond à votre recherche",
    PROCEED: "Valider",
    SAVE: "Enregistrer",
    SUCCESS: "Enregistré avec succès",
    UPDATE: "Modifier",
    LOADING: "Chargement...",
    NEXT: "Suivante",
    PREVIOUS: "Précédente",
    VALIDATE: "Valider",
    REMOVE: "Supprimer",
    EXPERT_MODE: "Mode expert",
    REMOVE_SUCCESS: ""
  },
  APP_BAR: {
    HOME: "Accueil",
  },
  HOME: {
    TITLE: "Référentiels terminologiques",
    WELCOME: "Bonjour {{name}}",
    WELCOME_PHRASE: "Bienvenue sur Koncept",
    VOCABULARIES: {
      CREATE: "Créer un nouveau référentiel",
      VISUALIZE_TITLE: "Liste des référentiels",
      IMPORT: "Importer un référentiel",
      EMPTY: "Aucun référentiel",
    },
  },
  VOCABULARY: {
    EMPTY_MESSAGE:
      "Le référentiel est vide, commencez par créer une nouvelle branche.",
    CREATE: "Créer un nouveau référentiel",
    CONCEPTS_COUNT: "{{count}} Concept",
    CONCEPTS_COUNT_plural: "{{count}} Concepts",
    REMOVE: {
      WARNING_MESSAGE:
        "Êtes-vous certain de vouloir supprimer ce référentiel ?",
      SUCCESS_MESSAGE: "Référentiel supprimé",
    },
    NO_PINNED_CONCEPT: "Aucun concept épinglé",
    TABS: {
      VIEW_TREE: "Hiérarchie",
      VIEW_COLLECTIONS: "Collections",
      RELATIONS: "Relations",
      SPLITTED_VIEWS: "Affichage multi-référentiels",
      PINNED_CONCEPTS: "Concept épinglé",
      PINNED_CONCEPTS_plural: "Concepts épinglés",
    },
    SIDE_POPUP: {
      TABS: {
        PREVIEW: "Prévisualisation",
        INFORMATION: "Informations",
        CONTEXT_MENU: "Actions",
        SEARCH: "Recherche",
      },
    },
    ACTIONS: {
      EDIT: "Modifier",
      REMOVE: "Supprimer",
      ADD_SCHEME: "Ajouter une branche",
    },
    PROPERTIES: {
      PREF_LABEL: "Label principal",
      ALT_LABEL: "Labels alternatifs",
      DEFINITION: "Définition",
    },
  },
  RELATIONS: {
    ADD_RELATIONS: "Ajouter cette relation",
    ADD_RELATIONS_plural: "Ajouter ces {{count}} relations",
    SAVE_RELATIONS: "Valider et terminer",
    ADD_TITLE: "Ajouter relation",
    SOURCE_CONCEPT: "Concept source",
    RELATION: "Relation",
    TARGET_CONCEPTS: "Concepts cibles",
    PINNED_CONCEPTS: "Concepts épinglés",
    SELECTED_CONCEPT: "Concept sélectionné",
    NO_SOURCE_CONCEPT_TIP:
      "Aucun concept n'est épinglé ni sélectionné pour ajouter des relations.",
    INNER_ASSOCIATIONS: "Relations sémantiques",
    OUTER_ASSOCIATIONS: "Relations d'alignement",
    RELATION_TYPES: {
      NARROWER: {
        TITLE: "Narrower",
      },
      NARROWER_TRANSITIVE: {
        TITLE: "Narrower transitive",
      },
      RELATED: {
        TITLE: "Related",
      },
      CLOSE_MATCH: {
        TITLE: "Close match",
      },
      EXACT_MATCH: {
        TITLE: "Exact match",
      },
      RELATED_MATCH: {
        TITLE: "Related match",
      },
      NARROWER_MATCH: {
        TITLE: "Narrower match",
      },
    },
  },
  SCHEME: {
    AUTOCOMPLETE: {
      CHOOSE: "Chercher une branche...",
      NO_RESULT: "Aucun résultat",
    },
    REMOVE: {
      WARNING_MESSAGE: "Êtes-vous certain de vouloir supprimer cette branche ?",
      SUCCESS_MESSAGE: "Branche supprimée",
    },
    ACTIONS: {
      CLOSE_NARROWERS: "Replier la branche",
      OPEN_NARROWERS: "Déplier la branche",
      SHOW_CONTEXT_MENU: "Afficher le menu",
      VIEW_DETAILS: "Afficher les détails",
      EDIT: "Modifier",
      REMOVE: "Supprimer",
      ADD_CONCEPT: "Ajouter un concept",
    },
    PROPERTIES: {
      PREF_LABEL: "Label principal",
      ALT_LABEL: "Labels alternatifs",
      DEFINITION: "Définition",
      COLOR: "Couleur"
    },
    VIRTUAL_DRAFT_SCHEME: {
      LABEL: "Concepts en vrac",
    },
  },
  CONCEPT: {
    LABEL: "Concept",
    TYPE: "Type de concept",
    REMOVE: {
      WARNING_MESSAGE: "Êtes-vous certain de vouloir supprimer ce concept ?",
      SUCCESS_MESSAGE: "Concept supprimé",
    },
    MOVE: {
      SUCCESS_MESSAGE: "Concept déplacé avec succès. Actualisation en cours...",
    },
    CREATE: {
      SUCCESS_MESSAGE: "Concept créé avec succès. Actualisation en cours...",
    },
    SUBSTITUTE: {
      SUBMIT: "Fusionner",
      RESUME_MESSAGE: "Fusionner ce concept \"{{sourceConcept}}\" par le concept \"{{targetConcept}}\".",
      HELP_MESSAGE: 'Cette action consiste à transférer les propriétés du concept "{{sourceConcept}}" vers le concept "{{targetConcept}}" puis de supprimer le concept "{{sourceConcept}}". Vous avez la possibilité de les modifier avant de valider la fusion.',
      SUCCESS_MESSAGE: "Concept fusionné avec succès. Actualisation en cours...",
    },
    NARROWERS_COUNT: "{{count}} concept",
    NARROWERS_COUNT_plural: "{{count}} concepts",
    AUTOCOMPLETE: {
      CHOOSE: "Chercher un concept...",
      NO_RESULT: "Aucun résultat",
    },
    ACTIONS: {
      CREATE_LINK: "Créer un lien",
      PIN: "Épingler",
      UNPIN: "Désépingler",
      CLOSE_NARROWERS: "Replier les sous-concepts",
      OPEN_NARROWERS: "Déplier les sous-concepts",
      SHOW_CONTEXT_MENU: "Afficher le menu",
      VIEW_DETAILS: "Afficher les détails",
      EDIT: "Modifier",
      REMOVE: "Supprimer",
      ADD_RELATION: "Ajouter une relation",
      MODIFY_RELATION: "Changer la relation",
      ADD_CHILDREN: "Ajouter un concept fils",
      SUBSTITUTE: "Fusionner avec un autre concept",
      NO_CHILD: "Aucun concept fils",
      MOVE: "Déplacer",
      TITLE: 'Actions pour "{{concept}}"',
      CHANGE_SCHEME: "Changer de branche",
      CHOOSE_SCHEME: "Choisir une branche",
      CHOOSE_BROADER: "Choisir un concept parent",
      CHANGE_BROADER: "Changer de concept parent",
      MOVE_TO_BROADER: 'Déplacer sous le concept "{{concept}}"',
      MOVE_TO_SCHEME: 'Déplacer sous la branche "{{scheme}}"',
    },
    PROPERTIES: {
      TITLE: "Propriétés",
      PREF_LABEL: "Label principal",
      PREF_LABELS: "Labels principaux",
      ALT_LABELS: "Labels alternatifs",
      HIDDEN_LABELS: "Labels cachés",
      NOTATION: "Notation",
      EXAMPLE: "Exemple d'utilisation",
      DEFINITION: "Définition",
      CHANGE_NOTE: "Notes de changements",
      SCOPE_NOTE: "Notes de context",
      HISTORY_NOTE: "Notes historiques",
      EDITORIAL_NOTE: "Notes éditoriales",
      TAGGINGS: "Tags associés",
      TAGGINGS_COUNT: "{{count}} tag associé",
      TAGGINGS_COUNT_plural: "{{count}} tags associés",
      TAGGINGS_ADD: "Ajout de {{count}} tag associé",
      TAGGINGS_ADD_plural: "Ajout de {{count}} tags associés",
    },
    EMPTY_PROPERTY: "Non renseigné",
    RELATIONSHIPS: {
      TITLE: "Relations",
      BROADER: "Concept parent",
      BROADER_TRANSITIVE: "Concept parent transitif",
      NARROWER: "Concepts fils",
      NARROWER_TRANSITIVE: "Concepts fils transitif",
      RELATED: "Concepts associés",
      EXACT_MATCH: "Concept alignés similaires",
      CLOSE_MATCH: "Concept alignés proches",
      RELATED_MATCH: "Concepts alignés associés",
      NARROWER_MATCH: "Concepts alignés plus spécifiques",
      BROADER_MATCH: "Concepts alignés plus générique",
      NONE: "Aucune relation",
    },
    EMPTY_RELATIONSHIP: "Aucun concept.",
  },
  SIGN_IN: {
    EMAIL: "Adresse mail",
    PASSWORD: "Mot de passe",
    PASSWORD_FORGOTTEN: "Mot de passe oublié",
    REDIRECT_SIGN_UP: "Créer un compte",
    REMEMBER_ME: "Se souvenir de moi.",
    SUBMIT: "Se connecter",
    TITLE: "Se connecter",
  },
  SIGN_UP: {
    EMAIL: "Adresse mail",
    FIRST_NAME: "Prénom",
    LAST_NAME: "Nom",
    PASSWORD: "Mot de passe",
    REDIRECT_SIGN_IN: "Vous avez déjà un compte ? Se connecter.",
    SUBMIT: "Créer le compte",
    TITLE: "Créer un compte",
    VALIDATE_PASSWORD: "Confirmation du mot de passe",
  },
  SEARCH: {
    PLACEHOLDER: "Rechercher...",
    NO_MATCH: "Aucun concept trouvé pour cette recherche...",
  },
};
